import { success, error, abort } from 'redux-saga-requests';
import { GET_DASH_ZONE_DEVICES } from '../constants';

const initialState = {};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_DASH_ZONE_DEVICES: {
      return {
        ...state,
        [action.meta.name]: {
          response: state[action.meta.name] ? state[action.meta.name].response : undefined,
          resolved: false,
          failed: false,
          error: null,
        },
      };
    }
    case success(GET_DASH_ZONE_DEVICES): {
      return {
        ...state,
        [action.meta.name]: {
          response: action.payload.data,
          resolved: true,
          failed: false,
          error: null,
        },
      };
    }
    case error(GET_DASH_ZONE_DEVICES): {
      if (action.payload.response.status >= 400 && action.payload.response.status < 600) {
        return {
          ...state,
          [action.meta.name]: {
            resolved: true,
            failed: true,
            error: action.payload.response.data.result.errorCode,
          },
        };
      }
      return {
        ...state,
        [action.meta.name]: {
          resolved: true,
          failed: true,
          error: action.payload.toString ? action.payload.toString() : '',
        },
      };
    }
    case abort(GET_DASH_ZONE_DEVICES):
      return {
        ...state,
      };
    default:
      return state;
  }
}
